export default __webpack_public_path__ + "static/media/erx-poslaju-icon.0e809e02.svg";